<template>
    <v-app class="ppv2-bg-white dark:ppv2-bg-dark">
        <v-container fluid>
            <v-row>
                <!-- Full width content without stepper -->
                <v-col cols="12" class="ppv2-pt-[46px]">
                    <div class="ppv2-bg-white dark:ppv2-bg-dark">
                        <Step1
                            :step="stepData"
                            :sizes="sizes"
                            :country_vat_rates="country_vat_rates"
                            :category="category"
                            :sub_category="sub_category"
                            :products="products"
                            :can-create-experience="canCreateExperience"
                            :can-create-forfait="canCreateForfait"
                            :can-create-formule="canCreateFormule"
                            :can-create-abonnement="canCreateAbonnement"
                            :plan-formule="planFormule"
                            :plan-forfait="planForfait"
                            :plan-abonnement="planAbonnement"
                            :plan-publish-additional-sales="planPublishAdditionalSales"
                            :tenant="tenant"
                            @next-step="handleNextStep"
                        />
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import Step1 from './components/Step1.vue'
import normalizeSize from '../../../utils/normalizeSize'

export default {
    components: { Step1 },
    props: {
        country_vat_rates: {
            type: Array,
        },
        products: {
            type: Array,
        },
        category: {
            type: Object,
        },
        sub_category: {
            type: Object,
        },
        canCreateExperience: {
            type: Boolean,
            default: false,
        },
        canCreateForfait: {
            type: Boolean,
            default: false,
        },
        canCreateFormule: {
            type: Boolean,
            default: false,
        },
        canCreateAbonnement: {
            type: Boolean,
            default: false,
        },
        planFormule: {
            type: Object,
            default: () => null,
        },
        planForfait: {
            type: Object,
            default: () => null,
        },
        planAbonnement: {
            type: Object,
            default: null,
        },
        planPublishAdditionalSales: {
            type: Object,
            default: null,
        },
        tenant: {
            type: Object,
            default: () => null,
        },
    },
    data() {
        return {
            stepData: {
                id: 1,
                subtitle: this.$t('experience.step1.subtitle'),
                content: this.$t('experience.step1.content'),
            },
        }
    },
    methods: {
        handleNextStep(payload) {
            // Redirect to the appropriate create page based on the selected type
            if (payload && payload.type) {
                // Redirect to Package V3 page for "formule combiné"
                if (payload.type === 'pack') {
                    window.location.href = '/back-office/v3/package/create'
                    return
                }
                // Redirect to Treatment V3 page for "forfait"
                if (payload.type === 'forfait') {
                    window.location.href = '/back-office/v3/treatment/create'
                    return
                }
                // For other types (experience, abonnement), redirect to the experience create page
                window.location.href = '/back-office/v3/experience/create'
            }
        },
        normalizeSize,
    },
    computed: {
        sizes() {
            return {
                title: this.normalizeSize(32, true),
                subtitle: this.normalizeSize(14, true),
                subtitleMenu: this.normalizeSize(12, true),
                formStep: this.normalizeSize(15, true),
            }
        },
    },
}
</script>

<style scoped>
.v-sheet.v-stepper:not(.v-sheet--outlined) {
    box-shadow: none;
    height: 100%;
}
</style>
